import { Button, FileUpload } from '@p2p/components';
import { TGetOrderResponse, useUploadReceiptsMutation } from '@p2p/services';
import { routes } from '@p2p/shared/routing';
import classNames from 'classnames';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from '../../styles.module.scss';
import innerStyles from './TransferUpload.module.scss';

interface ITransferIssuesProps {
  order: TGetOrderResponse;
  handleBack: () => void;
}

export const TransferUpload: FC<ITransferIssuesProps> = ({ order, handleBack }) => {
  const navigate = useNavigate();
  const [uploadReceipts, { isLoading: isUploading }] = useUploadReceiptsMutation();
  const [error, setError] = useState<string>('');
  const [files, setFiles] = useState<File[]>([]);

  const onSubmit = () => {
    if (isUploading) {
      return;
    }

    if (!files.length) {
      setError('Пожалуйста, загрузите чек об оплате.');
      return;
    }

    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });

    if (!order.id) {
      setError('Ошибка! Заказ не найден.');
      return;
    }

    uploadReceipts({ body: formData, id: order.id })
      .unwrap()
      .then(() => {
        navigate(routes.transferSearch.path({ id: order.id }));
        const transferUploadFiles = localStorage.getItem('transfer_upload_files');
        const filesCount = transferUploadFiles ? JSON.parse(transferUploadFiles).files : 0;

        if (filesCount) {
          localStorage.setItem(
            'transfer_upload_files',
            JSON.stringify({
              files: Number(filesCount) + files.length,
              orderId: order.id,
            }),
          );
        } else {
          localStorage.setItem(
            'transfer_upload_files',
            JSON.stringify({
              files: files.length,
              orderId: order.id,
            }),
          );
        }
      })
      .catch((err) => {
        const data = err?.data?.files;

        if (data?.length > 0) {
          setError(data[0]);
        }

        if (data?.file?.length > 0) {
          setError(data.file[0]);
        }
      });
  };

  return (
    <div
      className={classNames(
        styles.transfer_dialog,
        styles.upload_container,
        innerStyles.container,
        innerStyles.transfer_dialog,
      )}
    >
      <div className={classNames(styles.transfer_dialog__title, styles.text_left)}>
        Загрузите чек
      </div>

      <div className={styles.transfer_dialog__notice}>
        Пожалуйста, загрузите чек об оплате, на котором четко видны реквизиты получателя.
      </div>

      <FileUpload
        files={files}
        setFiles={setFiles}
        error={error}
        setError={setError}
        maxCountFiles={3}
        allowedFormats={['jpeg', 'jpg', 'pdf', 'png']}
        multiple
        maxFileSize={1}
      />

      <div className={styles.transfer_dialog__actions}>
        <Button onClick={onSubmit} disabled={isUploading}>
          Отправить
        </Button>
        <Button onClick={handleBack} variant="outlined">
          Вернуться к платежу
        </Button>
      </div>
    </div>
  );
};
